import { IEntityBulkAssignmentState } from "../types";

const state = (): IEntityBulkAssignmentState => ({
  isWorkflowActive: false,
  currentStep: null,
  entityType: null,
  entity: null,
  organizationId: null,
  assignedEmployees: [],
  employeesPaginationMeta: null,
  employeesSearchQuery: "",
  employeesPageNo: 1,
  isFetchingEmployees: false,
  isAssigning: false,
  assignmentOptions: [],
  isFetchingAssignmentOptions: false,
  lastSuccessfulAssignment: null,
});

export default state;
